"use client";

import { api } from "@convex/_generated/api";
import { useQuery } from "convex/react";
import Link from "next/link";
import { LoadoutCard } from "@/app/loadouts/loadout-card";
import { Loader } from "@/components/loader";
import type { UserProfile } from "../utils";

const MAX_LOADOUTS = 6;

type LoadoutsSectionProps = {
  profile: UserProfile;
};

export function LoadoutsSection({ profile }: LoadoutsSectionProps) {
  const loadoutsQuery = useQuery(api.users.queries.getUserLoadouts, {
    userId: profile._id,
    paginationOpts: { numItems: 6, cursor: null },
  });

  if (loadoutsQuery === undefined) {
    return (
      <div className="flex justify-center py-12">
        <Loader />
      </div>
    );
  }

  const loadouts = loadoutsQuery.page;

  if (loadouts.length === 0) {
    return (
      <div className="py-12 text-center">
        <h3 className="mb-2 font-semibold text-xl">No loadouts yet</h3>
        <p className="text-muted-foreground">
          {profile.username || "This user"} hasn't created any loadouts yet.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {profile.stats.totalLoadouts > MAX_LOADOUTS && (
        <div className="flex justify-end">
          <Link
            className="font-mono text-[#46C8E0] text-xs tracking-wider hover:text-[#7bd9ea]"
            href={`/loadouts?user=${profile.username || profile._id}`}
          >
            VIEW ALL →
          </Link>
        </div>
      )}

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {loadouts.map((loadout) => (
          <LoadoutCard key={loadout._id} loadout={loadout} />
        ))}
      </div>
    </div>
  );
}
